import * as serializer from 'basic-editor-value-serializer';
import { copyProperties } from 'utilities';

function _isInline(element) {

  return serializer.inlineElements.includes(element.type);

}

export default function withInlines(editor) {

  const { isInline } = editor;

  const overrides = {
    isInline(element) {

      return _isInline(element) || isInline(element);

    }
  };

  return copyProperties(overrides, editor);

}